"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.list.name': 'Nome del Test',
    'botTest.list.date': 'Data del Test',
    'botTest.list.testersCount': 'Tester',
    'botTest.list.targetsCount': 'Obiettivi',
};
